import { PrismicRichText } from "@prismicio/react";
import clsx from "clsx";
import React from "react";
import { PrismicReusableContentDataBodyTextAndLinkCta } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import * as FA from "../../styles/fontawesome";
import { graphql } from "gatsby";

export const query = graphql`
  fragment TextAndLinkCtaModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyTextAndLinkCta {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
        cta_text
        cta_link {
          url
          target
        }
        cta_type
        cta_theme
        footer {
          richText
          text
        }
      }
    }
  }
`;

export type ITextAndLinkCtaProps = {
  slice: PrismicReusableContentDataBodyTextAndLinkCta;
};

const TextAndLinkCta = (props: ITextAndLinkCtaProps) => {
  const { slice } = props;
  const { primary } = slice;

  return (
    <div className={clsx(["", primary?.css_class])}>
      <PrismicRichText
        field={primary.heading.richText}
        components={htmlSerializer}
      />
      <PrismicRichText
        field={primary.description.richText}
        components={htmlSerializer}
      />
      {primary?.cta_text && primary?.cta_link && primary?.cta_link?.url && (
        <div>
          <a
            href={primary?.cta_link?.url}
            target={primary?.cta_link?.target || "_self"}
            className={clsx([
              primary?.cta_type,
              primary?.cta_theme,
              primary?.cta_type === "button" && "py-2 px-8 rounded text-lg",
              primary?.cta_type === "link" && "text-lg",
            ])}
          >
            {primary?.cta_text}
            {primary?.cta_theme === "link-with-arrow" && (
              <span className="ml-2" css={FA.ArrowRightRegular} />
            )}
          </a>
        </div>
      )}
      {primary.footer && (
        <footer>
          <PrismicRichText
            field={primary.footer.richText}
            components={htmlSerializer}
          />
        </footer>
      )}
    </div>
  );
};

export default TextAndLinkCta;
